import React, { useState } from 'react';
import '../CasinoGamesGrid/CasinoGamesGrid.css';
import { useLiveCasinoState } from '../../../hooks/use-live-casino-state.hook';
import { RecommendationsCarousel } from './RecommendationsCarousel';

export const RecommendationGamesGrid = ({
    gamesByCategories = [],
}) => {
    const [liveCasinoData, setLiveCasinoData] = useState(null);

    // get live casino data
    useLiveCasinoState(setLiveCasinoData);

    return (
        <>
            {gamesByCategories.map((gamesCategory, index) =>
                <RecommendationsCarousel
                    key={index}
                    index={index}
                    liveCasinoData={liveCasinoData}
                    gamesCategory={gamesCategory}
                />
            )}
        </>
    );
};
